import {
  GET_ETC_MISSING,
  GET_ETC_MISSING_SUCCESS,
  HIDE_ETC_Missing_MESSAGE,
  ON_ADD_ETC_Missing,
  ON_ADD_ETC_Missing_Success,
  ON_HIDE_ETC_Missing_LOADER,
  ON_SHOW_ETC_Missing_LOADER,
  SHOW_ETC_Missing_MESSAGE
} from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  etcMissing: null,
  etcMissionId: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_ADD_ETC_Missing_Success: {
      return {
        ...state,
        loader: false,
        etcMissionId: action.payload
      }
    }
    case ON_ADD_ETC_Missing: {
      return {
        ...state,
        loader: true
      }
    }
    case SHOW_ETC_Missing_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_ETC_Missing_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    // case ON_SHOW_Missing_LOADER: {
    //   return {
    //     ...state,
    //     loader: true
    //   }
    // }
    case ON_HIDE_ETC_Missing_LOADER: {
      return {
        ...state,
        loader: false
      }
    }

    case GET_ETC_MISSING: {
      return {
        ...state,
        loader: true
      };
    }

    case GET_ETC_MISSING_SUCCESS: {
      return {
        ...state,
        loader: false,
        etcMissing: action.payload,
      };
    }


    case ON_SHOW_ETC_Missing_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    default:
      return state;
  }
};
